import { TFunction } from 'i18next';
import {
  FilteredContentSuggest,
  Section,
  AllContentResults,
  TopContentResult,
} from '../../../../components/molecules/Form/components/ComboBox';
import { isEmptyArray, isNotNullOrUndefined, isNullOrUndefined } from '../../../../lib/typeGuards';

export default (t: TFunction) =>
  (contentSuggestResponse?: FilteredContentSuggest): Section<AllContentResults | TopContentResult>[] => {
    if (
      isNullOrUndefined(contentSuggestResponse) ||
      (contentSuggestResponse && isEmptyArray(contentSuggestResponse.topResults))
    )
      return [];

    const topResults: TopContentResult[] = contentSuggestResponse.topResults.map(r => ({
      ...r,
      type: 'topContentResult',
    }));

    const allResultsItem: AllContentResults | undefined =
      topResults.length > 0 && contentSuggestResponse.allUrl
        ? {
            id: `allFilteredContentResults`,
            type: 'allContentResult',
            pageLink: {
              url: contentSuggestResponse.allUrl.url,
              name: t(`filteredContent.resultsLabel`, {
                resultsIn: contentSuggestResponse.filteredPage && contentSuggestResponse.filteredPage.title,
              }),
            },
          }
        : undefined;

    const combinedResults = [...topResults, allResultsItem].filter(isNotNullOrUndefined);
    return [
      {
        key: 'filteredContent',
        results: combinedResults,
        headline: `${t('filteredContent.headline', {
          resultsIn: contentSuggestResponse.filteredPage && contentSuggestResponse.filteredPage.title,
        })}`,
      },
    ];
  };
